interface StepConfig {
  id: string;
  component: Function;
  props: string[];
  image: string;
  slug?: string;
  isOptional?: boolean;
  isComplete: Function;
}

export default class Step {
  public id;
  public slug;
  public props;
  public image;
  public component;
  public isOptional;
  public isComplete;
  public prev: Step | null;
  public next: Step | null;

  constructor({ id, slug, props, image, component, isOptional, isComplete }: StepConfig) {
    this.id = id;
    this.slug = slug || id;
    this.props = props;
    this.image = image;
    this.component = component;
    this.isOptional = !!isOptional;
    this.isComplete = isComplete;

    this.prev = null;
    this.next = null;
  }

  public setPrev(step: Step) {
    this.prev = step;
  }

  public setNext(step: Step) {
    this.next = step;
  }
}
